function Footer() {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-text text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="mb-4 text-secondary font-serif text-xl">Les Jolies Choses</h3>
            <p className="text-white/70 leading-relaxed font-sans">
              Votre dépôt-vente de mode féminine pour une élégance durable et responsable.
            </p>
          </div>

          <div>
            <h4 className="mb-4 text-secondary font-serif">Navigation</h4>
            <ul className="space-y-2 text-white/70 font-sans">
              <li>
                <button
                  onClick={() => scrollToSection("accueil")}
                  className="hover:text-secondary transition-colors duration-300"
                >
                  Accueil
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("a-propos")}
                  className="hover:text-secondary transition-colors duration-300"
                >
                  À propos
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("contact")}
                  className="hover:text-secondary transition-colors duration-300"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-secondary font-serif">Contact</h4>
            <ul className="space-y-2 text-white/70 font-sans">
              <li>66 Av. de Mazargues</li>
              <li>13008 Marseille</li>
              <li>04 91 76 09 63</li>
              <li>karoli13@yahoo.fr</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-white/60 text-sm font-sans">
            © {new Date().getFullYear()} Les Jolies Choses. Tous droits réservés.
          </p>
          <div className="flex items-center gap-2 text-white/60 text-sm font-sans">
            <span>Fait avec</span>
            <svg className="w-4 h-4 text-secondary" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
            </svg>
            <span>à Marseille</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;

